import { GetUsers } from '../../../services/user/GetUsers';
import { UserService } from '../../../services/user/user.service';
import { GetProjects } from '../../../services/project-list/GetProjects';
import { ProjectListService } from '../../../services/project-list/project-list.service';
import { taskLabelToLabel } from '../../../model/task/taskLabel';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Task } from 'src/app/shared/model/task/task';

@Component({
  selector: 'digires-task-entry',
  templateUrl: './task-entry.component.html',
  styleUrls: ['./task-entry.component.scss']
})
export class TaskEntryComponent implements OnChanges {

  @Input() task: Task;

  project: GetProjects;
  owner: GetUsers;

  constructor(
    private projectListService: ProjectListService,
    private userService: UserService
  ) { }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if(changes.task) {
      this.project = await this.projectListService.fetchProjectById(this.task.projectId);
      this.owner = await this.userService.loadUserById(this.task.ownerId);
    }
  }

  getProjectName() {
    return this.project.name;
  }

  getUserName() {
    if (this.owner) {
      return this.owner.fullName
    }
    return 'Owner not found (' + this.task.ownerId + ')';
  }

  getDate(task: Task) {
    if (task.dueDate) {
      const date = new Date(task.dueDate);
      const month = date.getMonth() + 1;
      return date.getDate() + '/' + month + '/' + date.getFullYear();
    }
    return null
  }

  labelToLabel() {
    return taskLabelToLabel[this.task.label];
  }
}
